// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:1440px){.swiper-slide .brand-suggested-brand-item_wrapper .brand-suggested-brand-item_banner-wrapper a[data-v-3b6c53a4]{height:150px!important}}.brand-suggested-brand-item_wrapper .brand-suggested-brand-item_banner-wrapper a[data-v-3b6c53a4]{height:175px;display:block}.brand-suggested-brand-item_wrapper .brand-suggested-brand-item_banner-wrapper img[data-v-3b6c53a4]{height:100%}", ""]);
// Exports
module.exports = exports;
